import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-app-info-list-item',
  templateUrl: './app-info-list-item.component.html',
  styleUrls: ['./app-info-list-item.component.scss']
})
export class AppInfoListItemComponent implements OnInit {
  @Input() label: string;
  @Input() type: string;
  @Input() value: any;
  @Input() text: string;
  @Input() tooltipText: string;
  @Input() showFreemiumLock: boolean;
  @Input() sectionLink: string;
  @Input() canRouteToDiscovery: boolean;
  @Input() discoveryRouteLink: any;
  @Input() discoveryQueryParams: any;
  @Input() icon: string;
  @Output() goToSectionClick: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
    if (this.value === 'N/A') {
      this.canRouteToDiscovery = false;
    }
  }

  goToSection() {
    this.goToSectionClick.emit(this.sectionLink);
  }

}
